import { render } from "./Wrong.vue?vue&type=template&id=c0a4b5b8"
import script from "./Wrong.vue?vue&type=script&lang=js"
export * from "./Wrong.vue?vue&type=script&lang=js"
script.render = render

export default script